import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(i, o, e, r, d, t, s, v, n, u, a) {
    super(
      i,
      void 0,
      void 0,
      o,
      e,
      void 0,
      void 0,
      void 0,
      (r = r || InAppMessage.DismissType.MANUAL),
      d,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      s,
      void 0,
      void 0,
      void 0,
      v,
      void 0,
      void 0,
      void 0,
      n,
      u,
    ),
      (this.messageFields = a),
      (this.messageFields = a);
  }
  do() {
    return !1;
  }
  p(i) {
    if (this.Ae === InAppMessage.Ce.Zr) {
      if (this.vo) return !1;
      this.vo = !0;
    }
    return this.Et.Dt(i), !0;
  }
  Y() {
    const i = super.Y(HtmlMessage.it);
    return (i[InAppMessage.tt.uo] = this.messageFields), i;
  }
  static Yr(i) {
    return new HtmlMessage(
      i[InAppMessage.tt.ea],
      i[InAppMessage.tt.bt],
      i[InAppMessage.tt.sa],
      i[InAppMessage.tt.aa],
      i[InAppMessage.tt.oa],
      i[InAppMessage.tt.la],
      i[InAppMessage.tt.ga],
      i[InAppMessage.tt.ha],
      i[InAppMessage.tt.Sa],
      i[InAppMessage.tt.CSS],
      i[InAppMessage.tt.uo],
    );
  }
}
HtmlMessage.it = InAppMessage.Ce.Zr;
